import type {
    DateOnlyRange,
    DatePickerSelectionMode,
    DatePickerVariant,
} from "@design-system/DatePicker/DatePicker.types";

export const datePickerVariants: ReadonlyArray<{
    value: DatePickerVariant;
    label: string;
}> = [
    { value: "button", label: "Button" },
    { value: "embedded", label: "Embedded" },
];

export const getAvailableModes = (
    mode: DatePickerSelectionMode,
    modeAvailability: "single" | "multiple",
): readonly DatePickerSelectionMode[] => {
    if (
        mode === "month" ||
        mode === "monthRange" ||
        mode === "quarter" ||
        mode === "year"
    ) {
        if (modeAvailability === "multiple") {
            return ["month", "monthRange", "quarter", "year"];
        }
        return [mode];
    }
    if (modeAvailability === "multiple") {
        return ["day", "range", "week"];
    }
    return [mode];
};

const formatRangeOutput = (range: DateOnlyRange | undefined) => ({
    from: range?.from ?? null,
    to: range?.to ?? null,
});

export const getDatePickerOutput = ({
    mode,
    dayValue,
    rangeValue,
    weekValue,
    monthValue,
    monthRangeValue,
    quarterValue,
    yearValue,
}: {
    mode: DatePickerSelectionMode;
    dayValue?: string;
    rangeValue?: DateOnlyRange;
    weekValue?: DateOnlyRange;
    monthValue?: DateOnlyRange;
    monthRangeValue?: DateOnlyRange;
    quarterValue?: DateOnlyRange;
    yearValue?: DateOnlyRange;
}) => {
    if (mode === "day") {
        return dayValue ?? null;
    }
    if (mode === "range") {
        return formatRangeOutput(rangeValue);
    }
    if (mode === "week") {
        return formatRangeOutput(weekValue);
    }
    if (mode === "month") {
        return formatRangeOutput(monthValue);
    }
    if (mode === "monthRange") {
        return formatRangeOutput(monthRangeValue);
    }
    return formatRangeOutput(mode === "quarter" ? quarterValue : yearValue);
};
